import * as React from "react"
import { connect } from "react-redux"
import trans from "trans"
import store from "store";

import {
    css,
    Section,
    Theme,
    Button,
    Grid,
    GridCell,
    Icon,
    Tr,
    Td,
    Div,
} from "@bdfx/mergado-ui-kit"
import { ItemInterface, ReactSortable } from "react-sortablejs"

import { RouterType, withRouter } from "app/components/routes";

import {
    getProjectSettings as apiGetProjectSettings,
    saveSettingsOrder as apiSaveSettingsOrder,
    eshopId,
    getCustomPalettes,
    getDefaultPalettes,
    getGradients,
    getSizes,
    projectId,
} from "app/helpers/api";

import { CustomPalette, CustomPalettesFormType, Gradient, Palette, SettingsFormType } from "app/types/model-types";

import {
    SAVE_SETTINGS_ORDER,
    GET_CUSTOM_PALETTES,
    setPalettesToStore,
    setGradientsToStore, GET_GRADIENTS,
    UPDATE_SETTINGS,
    setSizesToStore
} from "template-edit/reducers";

import {
    updateInputValue as change,
    initForm
} from "app/reducers/form";

import { SettingsSpinner } from "../components/spinner";

import { AxiosResponse } from "axios";
import { inIframe } from "app/helpers/mergado";
import { createToast } from "actions";
import { selectFormValues } from "app/reducers/form"
import toastFactory from "app/helpers/toast_factory";
import { IconGradients, IconMCP, IconPalette, IconSimilarity } from "app/icons";
import { DarkGrayColor } from "app/helpers/colors";

import Palettes from "../components/palettes";
import Gradients from "../components/gradients";
import Fonts from "../components/fonts";
import UISettings from "../components/ui-settings";
import EditLayout from "template-edit/components/edit-layout"
import VisualSimilarity from "settings/components/visual-similarity";
import ImportFromProject from "settings/components/import-from-project";
import SizesSettings, { SizeItem } from "../components/sizes-settings"
import ProjectSettings from "../components/project-settings"
import CustomSets from "../components/custom-sets";
import HidingRules from "../components/hiding-rules";

import {
    saveProjectSettings as apiSaveProjectSettings,
} from "app/helpers/api";
import { debounce, find, forEach } from "lodash";
import MCPSettings from "settings/components/mcp-settings";

interface Props {
    router: RouterType
    settingsForm: SettingsFormType
    customPalettesForm: CustomPalettesFormType
    palettes: Palette[]
    gradients: Gradient[]
    setPalettesToStore: typeof setPalettesToStore
    setGradientsToStore: typeof setGradientsToStore
    setSizesToStore: typeof setSizesToStore
    createToast: typeof createToast
    initForm: typeof initForm
}

interface State {
    showMCPConnector: boolean
    showProjectSettings: boolean
    showUISettings: boolean
    showSizes: boolean
    showCustomSets: boolean
    showHidingRules: boolean
    showCollageLayouts: boolean
    showPalettes: boolean
    showGradients: boolean
    showImportFromProject: boolean
    showVisualSimilarity: boolean
    showFonts: boolean
    isLoaded: boolean
    order: string[]
}

export const iconSize = 32

export type ShowCategoryType = 'showMCPConnector' | 'showProjectSettings' | 'showSizes' | 'showCustomSets' | 'showPalettes' | 'showGradients' | 'showImportFromProject' | 'showHidingRules' | 'showCollageLayouts' | 'showFonts' | 'showUISettings' | 'showVisualSimilarity'

type SectionType = {
    type: ShowCategoryType
    icon: JSX.Element
    component: JSX.Element
}

const initOrder = [
    'showMCPConnector',
    'showProjectSettings',
    'showUISettings',
    'showSizes',
    'showCustomSets',
    'showPalettes',
    'showGradients',
    'showImportFromProject',
    'showFonts',
    'showHidingRules',
    'showCollageLayouts',
    'showVisualSimilarity',

]

class Settings extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
            showMCPConnector: false,
            showProjectSettings: false,
            showUISettings: false,
            showSizes: false,
            showCustomSets: false,
            showHidingRules: false,
            showCollageLayouts: false,
            showPalettes: false,
            showGradients: false,
            showImportFromProject: false,
            showFonts: false,
            showVisualSimilarity: false,
            isLoaded: false,
            order: initOrder,
        }
    }

    componentDidMount() {
        const { palettes, gradients } = this.props

        apiGetProjectSettings()
            .then((response: any) => {
                this.props.initForm('settingsForm', response.data)
                this.setState({ isLoaded: true })

                if (response.data.settings_order) {
                    const parsed = JSON.parse(response.data.settings_order)

                    let newOrder = [];
                    forEach(parsed, (value) => {
                        if (this.state.order.includes(value.name)) {
                            newOrder.push(value.name)
                            this.state[value.name] = !!(value.show === 'true')
                        }
                    })

                    forEach(this.state.order, (key) => {
                        if (!this.state.order.includes(key)) {
                            newOrder.push(key)
                            this.state[key] = false //default
                        }
                    })

                    this.setState({ order: newOrder })
                }
            })
            .catch(error => {
                console.error(error, error.response || null)
            })
            .finally(() => {
                this.setState({ isLoaded: true })

                const showCategory = this.props.router.params.showcategory
                if (showCategory && (initOrder.includes(showCategory) || this.state.order.includes(showCategory))) {
                    let updatedState = { ...this.state }
                    updatedState[showCategory] = true
                    this.setState(updatedState)
                    const target = document.getElementById(showCategory)
                    if (target) {
                        target.focus()
                        target.scrollIntoView()
                    }
                }
            })

        if (!palettes) {
            getDefaultPalettes()
                .then((response: AxiosResponse<any>) => {
                    this.props.setPalettesToStore(response.data)
                })
                .catch(error => {
                    this.props.createToast(toastFactory(GET_CUSTOM_PALETTES.ERROR, error))
                })
        }

        if (!gradients) {
            getGradients()
                .then((response: AxiosResponse<Gradient[]>) => {
                    this.props.setGradientsToStore(response.data)
                })
                .catch(error => {
                    this.props.createToast(toastFactory(GET_GRADIENTS.ERROR, error))
                })
        }

        getCustomPalettes()
            .then((response: AxiosResponse<CustomPalette[]>) => {
                this.props.initForm('customPalettesForm', response.data)
            })
            .catch(error => {
                this.props.createToast(toastFactory(GET_CUSTOM_PALETTES.ERROR, error))
            })

        getSizes()
            .then((response: AxiosResponse<SizeItem[]>) => {
                this.props.setSizesToStore(response.data)
            })
            .catch((e) => console.error('cannot get sizes', e))
    }

    showOnClick = (type: string, elUp: any, elDown: any = null) => {
        const currentState = this.state[type]
        let newState = {};
        newState[type] = !currentState

        return <div style={{ cursor: 'pointer', height: iconSize }} onClick={() => {
            this.setState(newState)
            this.props.router.navigate(`/eshop/${eshopId}/project/${projectId}/settings/${type}`)
        }}>{elDown ? (currentState ? elUp : elDown) : elUp}</div>
    }

    saveSettings = () => {
        apiSaveProjectSettings(this.props.settingsForm)
            .then((response: AxiosResponse<SettingsFormType>) => {
            })
            .catch(error => {
                store.dispatch(createToast(toastFactory(UPDATE_SETTINGS.ERROR, error)))
            })
    }

    saveSettingsDebounced = debounce(() => {
        this.saveSettings()
    }, 650)

    newSection = (section: SectionType) => {
        const isVisible = this.state[section.type] || false

        return <Tr rowId={section.type} key={`row-${section.type}-${isVisible ? 'v' : 'i'}`}>
            <Td className={'group'}>
                <Grid cols={'auto auto'} id={section.type}>
                    <GridCell className={'s-header left drag-handle unselectable'}>
                        {this.showOnClick(section.type, <div style={{ cursor: "grab" }}>
                            <Icon type="drag-handle-dots-2-radix" color="#888" size={18} />
                            {section.icon}
                        </div>)}
                    </GridCell>
                    <GridCell className={'s-header right unselectable'}>
                        {this.showOnClick(section.type, <Icon type={'chevron-up'} text={trans('show_less')} />, <Icon type={'chevron-down'} text={trans('show_more')} />)}
                    </GridCell>
                    <GridCell col={'1/-1'}>
                        {isVisible &&
                            <StyledTwoColumnsGrid dataType={section.type}>
                                {section.component}
                            </StyledTwoColumnsGrid>
                        }
                    </GridCell>
                </Grid>
            </Td>
        </Tr>
    }

    sections = [
        { type: 'showMCPConnector', icon: <IconMCP size={iconSize} text={trans('mcp')} color={DarkGrayColor} />, component: <MCPSettings /> },
        { type: 'showProjectSettings', icon: <Icon type={'settings-light'} size={iconSize} text={trans('project_settings')} color={DarkGrayColor} />, component: <ProjectSettings /> },
        { type: 'showUISettings', icon: <Icon type={'user-light'} size={iconSize} color={Theme.steelblue} text={trans('ui_settings')} />, component: <UISettings saveSettingsDebounced={this.saveSettingsDebounced} /> },
        { type: 'showSizes', icon: <Icon type={'maximise-light'} size={iconSize} text={trans('nav_size')} color={'#5b7e7e'} />, component: <SizesSettings /> },
        { type: 'showHidingRules', icon: <Icon type={'ban'} size={iconSize} text={trans('hiding_products')} color={Theme.red} />, component: <HidingRules saveSettingsDebounced={this.saveSettingsDebounced} /> },
        { type: 'showCustomSets', icon: <Icon type={'cloud-upload-light'} size={iconSize} text={trans('uploaded_images')} color={`#364b7b`} />, component: <CustomSets /> },
        { type: 'showCollageLayouts', icon: <Icon type={'th'} size={iconSize} text={trans('collage_layouts')} color={Theme.steelblue} />, component: <EditLayout isEditTemplateMode={false} /> },
        { type: 'showPalettes', icon: <IconPalette size={iconSize} text={trans('brand_colors')} />, component: <Palettes /> },
        { type: 'showGradients', icon: <IconGradients size={iconSize} text={trans('gradients')} />, component: <Gradients /> },
        { type: 'showImportFromProject', icon: <Icon type={'download'} size={iconSize} text={trans('import_from_project')} />, component: <ImportFromProject /> },
        { type: 'showFonts', icon: <Icon type={'font'} size={iconSize} color={Theme.steelblue} text={trans('fonts')} />, component: <Fonts /> },
        { type: 'showVisualSimilarity', icon: <IconSimilarity size={iconSize-4} text={trans('visual_similarity')} color={Theme.steelblue} />, component: <VisualSimilarity saveSettingsDebounced={this.saveSettingsDebounced}/> },
    ] as SectionType[]

    reorderSettings = (newOrder) => {
        this.setState({ order: newOrder })
    }

    saveSettingsOrder = () => {
        const settingsOrder = this.state.order.map(key => {
            return { name: key, show: this.state[key] ? 'true' : 'false' }
        })

        apiSaveSettingsOrder(JSON.stringify(settingsOrder))
            .then((response: any) => {
                this.props.initForm('settingsForm', response.data)
                this.props.createToast(toastFactory(SAVE_SETTINGS_ORDER.SUCCESS))
            })
            .catch(error => {
                this.props.createToast(toastFactory(SAVE_SETTINGS_ORDER.ERROR, error))
                console.error(error, settingsOrder)
            })
            .finally(() => this.setState({ isLoaded: true }))
    }

    getIds = (): string[] | null => {
        const { order } = this.state

        if (!order || order.length === 0) {
            return null
        }

        const difference = order.filter(x => !initOrder.includes(x)).concat(initOrder.filter(x => !order.includes(x)));

        return [...order, ...difference]
    }

    reorder = (list) => {
        const { order } = this.state
        const newOrder = list.map(i => i.id)
        if (order.join(',') !== newOrder.join(',')) {
            const o = newOrder.map(obj => parseInt(obj))
            this.setState({ order: o })
            this.reorderSettings(newOrder)
        }
    }

    render() {
        const { isLoaded } = this.state

        const ids = this.getIds()
        const list: ItemInterface[] = ids ? ids.map(id => { return { id: id, selected: this.state[id] ?? false } }) : []

        return (
            <StyledSection
                header={<Icon type={'settings-light'} size={iconSize} color={Theme.blue} text={trans('settings')} />}
                suffix={isLoaded ? <StyledButtonSave type={'void'} onClick={(e) => this.saveSettingsOrder()}><Icon type={'save-light'} color={'#fff'} text={trans("save_order")} /></StyledButtonSave> : <span />}
            >
                {ids ? <StyledTable>
                    <ReactSortable list={list} setList={this.reorder} handle=".drag-handle" tag="tbody">
                        {ids.map(o => {
                            const section = find(this.sections, (s) => {
                                return s.type === o
                            })

                            return section && section.type ? this.newSection(section) : <Tr key={`row-${o}`}>
                                <td colSpan={100}><Div padding="50px" maxWidth="600px" textAlign="center" margin="auto" fontStyle="italic">
                                </Div></td>
                            </Tr>
                        })}
                    </ReactSortable>
                </StyledTable> : <SettingsSpinner />
                }
            </StyledSection>
        )
    }
}

export const StyledButtonSave = css(Button)({
    padding: '4px 10px',
})

export const StyledSection = css(Section)({
    padding: 0,
    ' .m-content': {
        padding: 0,
    },
    '@media screen and (max-width: 1024px)': {
        ' .m-content': {
            paddingBottom: inIframe() ? '100px' : '10px',
            overflow: 'auto',
        },
    },
})

export const StyledTable = css('table')({
    width: '100%',
    ' .group': {
        padding: 0,
        margin: 0,
    },
    ' .muk-section': {
        marginBottom: 0,
    },
    ' .right': {
        textAlign: 'right',
    },
    ' .left': {
        textAlign: 'left',
    },
    ' .muk-icon__text': {
        padding: '3px 5px',
    },
    ' .s-header': {
        padding: '10px',
        justifySelf: 'stretch',
        alignSelf: 'stretch',
        fontSize: '15px',
        background: 'rgb(249, 249, 249)',
        borderBottom: '1px solid rgb(221, 221, 221)',
        borderRadius: '3px 3px 0px 0px',
    },
    ' .drag-handle': {
        verticalAlign: 'top',
        cursor: 'pointer',
    },
    ' .content-wrapper': {
        background: 'white',
        padding: '15px',
    },
    ' .muk-form-group': {
        marginBottom: 'auto !important',
    },
})

const StyledTwoColumnsGrid = css(Grid)({
    padding: '2px 10px',
    gridGap: '20px',
    '@media screen and (max-width: 800px)': {
        gridTemplateColumns: '1fr',
        gridGap: '10px',
    },
    borderBottom: '1px solid #ccc',
}, props => {
    return {
        gridTemplateColumns: props.dataType && [
            'showHidingRules',
            'showGradients',
            'showSizes',
            'showCustomSets',
            'showImportFromProject',
            'showFonts',
        ].includes(props.dataType) ? '1fr' : '1fr 1fr',
    }
})

function mapStateToProps(state) {
    return {
        settingsForm: selectFormValues(state, 'settingsForm'),
        customPalettesForm: selectFormValues(state, 'customPalettesForm'),
        palettes: state.palettes,
        gradients: state.gradients,
    }
}

export default connect(mapStateToProps, {
    initForm,
    change,
    setPalettesToStore,
    setGradientsToStore,
    createToast,
    setSizesToStore,
})(withRouter(Settings))